import { UsersProvider } from "@my-helpers/common";
import UsersView from "./users";
import Layout from "../layout";
import { useParams } from "react-router-dom";

const Users = () => {
    const { id } = useParams<{ id: string }>();
    return (
        <Layout>
            <UsersProvider userId={id} >
                <UsersView userId={id} />
            </UsersProvider>
        </Layout>
    );
};

export default Users;